import { SpinnerLegacy } from "../../components";
import { Dialog, DialogNavigation, DialogContent } from "../modal/Dialog";
import { useBusinessUserList } from "../../hooks/api/v2/businessUser/useBusinessUserList";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { BusinessUserJobTitleForm } from "./BusinessUserJobTitleForm";
import { ProfileImageUpload } from "./ProfileImageUpload";

type ProfileImageUploadDialogProps = {
  active: boolean;
  userId: number;
  onDismiss: () => void;
  onSuccess?: () => void;
};

export const ProfileImageUploadDialog = (
  props: ProfileImageUploadDialogProps,
) => {
  return (
    <Dialog active={props.active} onDismiss={props.onDismiss}>
      <ProfileImageUploadModalContent {...props} />
    </Dialog>
  );
};

export const ProfileImageUploadModalContent = ({
  onDismiss,
  onSuccess,
  userId,
}: ProfileImageUploadDialogProps) => {
  const { business } = useSellarCurrentBusiness();
  const businessId = business?.id;
  const businessUsersQuery = useBusinessUserList(
    {
      query: [
        {
          value: userId,
          type: "UserId",
          modifier: "EQUALS",
        },
      ],
    },
    {
      enabled: !!userId,
    },
  );

  const firstPage = businessUsersQuery.data?.pages[0];
  const businessUser =
    businessId && firstPage
      ? firstPage.find((userBusiness) => userBusiness.BusinessId === businessId)
      : undefined;

  return (
    <>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Your profile"}
      />
      <DialogContent>
        {(businessUsersQuery.isLoading &&
          businessUsersQuery.fetchStatus !== "idle") ||
        !businessUser?.id ? (
          <SpinnerLegacy />
        ) : (
          <>
            <ProfileImageUpload />
            <BusinessUserJobTitleForm
              businessUserId={parseInt(businessUser.id.toString())}
              jobTitle={businessUser.jobTitle}
              onDismiss={onDismiss}
              onSuccess={onSuccess}
            />
          </>
        )}
      </DialogContent>
    </>
  );
};
